import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import StoreService from '../../services/storeService';
import './StoreSwitcher.css';

const StoreSwitcher = ({ stores, activeStoreId, onStoreChange }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleStoreSelect = async (storeId) => {
    if (storeId === activeStoreId) {
      setIsOpen(false);
      return;
    }

    try {
      setLoading(true);
      // Set the active store
      StoreService.setActiveStoreId(storeId);
      
      // Notify parent component
      if (onStoreChange) {
        await onStoreChange(storeId);
      }
      
      setIsOpen(false);
    } catch (error) {
      console.error('Error switching store:', error);
    } finally {
      setLoading(false);
    }
  };

  const activeStore = stores.find(store => store.$id === activeStoreId) || stores[0];

  if (!stores || stores.length === 0) {
    return null;
  }

  return (
    <div className="store-switcher" ref={dropdownRef}>
      <button
        className="store-switcher-button"
        onClick={() => setIsOpen(!isOpen)}
        disabled={loading}
      >
        <span className="store-name">{activeStore?.storeName || 'Select Store'}</span>
        <img 
          className={`chevron-icon ${isOpen ? 'open' : ''}`} 
          alt="" 
          src="/icons/chevron-down.svg" 
        />
      </button>
      
      {isOpen && (
        <div className="store-switcher-dropdown">
          <div className="store-switcher-header">
            <span>Switch Store</span>
            <span className="store-count">{stores.length} stores</span>
          </div>
          <div className="store-switcher-list">
            {stores.map((store) => (
              <button
                key={store.$id}
                className={`store-switcher-item ${
                  store.$id === activeStoreId ? 'active' : ''
                }`}
                onClick={() => handleStoreSelect(store.$id)}
                disabled={loading}
              >
                <div className="store-item-info">
                  <span className="store-item-name">{store.storeName}</span>
                  {store.region && store.district && (
                    <span className="store-item-location">
                      {store.district}, {store.region}
                    </span>
                  )}
                </div>
                {store.$id === activeStoreId && (
                  <span className="store-item-check">✓</span>
                )}
              </button>
            ))}
          </div>
          <div className="store-switcher-footer">
            <button
              className="store-switcher-add"
              onClick={() => {
                setIsOpen(false);
                navigate('/dashboard/stores/add');
              }}
            >
              + Add New Store
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default StoreSwitcher;

